export const __buttonWrapper = ({ theme, isFullWidth, isVisible = true }) => ({
	cursor: 'pointer',
	borderRadius: theme.primary(theme).borderRadius,
	width: isFullWidth ? '100%' : 'auto',
	extend: [
		{
			condition: !isVisible,
			style: {
				visibility: 'hidden',
			},
		},
	],
})

export const __buttonText = ({
	theme,
	disabled,
	btnColor,
	size,
	isFullWidth,
	isFloat,
}) => {
	return {
		textAlign: 'center',
		color: theme.colors.white,
		borderRadius: theme.primary(theme).borderRadius,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		cursor: disabled ? 'default' : 'pointer',
		extend: [
			{
				condition: btnColor === 'PRIMARY',
				style: {
					backgroundColor: theme.primary(theme).backgroundColor,
					border: `1px solid ${theme.primary(theme).backgroundColor}`,
					color: theme.primary(theme).colorWhite,
				},
			},
			{
				condition: btnColor === 'SECONDARY',
				style: {
					backgroundColor: 'transparent',
					border: `1px solid ${theme.primary(theme).backgroundColor}`,
					color: theme.primary(theme).backgroundColor,
					flex: 'unset',
				},
			},
			{
				condition: btnColor === 'TEXT',
				style: {
					backgroundColor: 'transparent',
					border: 'none',
					color: theme.primary(theme).backgroundColor,
				},
			},
			{
				condition: size === 'SMALL',
				style: {
					padding: '0',
					width: 72,
					flex: 'unset',
					fontSize: theme.font.size12,
					height: '24px',
				},
			},
			{
				condition: size === 'MEDIUM',
				style: {
					// ...padding(theme.spaces[12], theme.spaces[4]),
					width: isFullWidth ? '100%' : 140,
					flex: 'unset',
					fontSize: theme.font.size14,
					height: '32px',
				},
			},
			{
				condition: size === 'LARGE',
				style: {
					// ...padding(theme.spaces[16], theme.spaces[4]),
					width: isFullWidth ? '100%' : 160,
					flex: 'unset',
					fontSize: theme.font.size16,
					height: '40px',
				},
			},
			{
				condition: disabled && btnColor !== 'TEXT',
				style: {
					opacity: '1',
					backgroundColor: theme.colors.lightGrey3,
					border: 'none',
					color: theme.colors.white,
				},
			},
			{
				condition: disabled && btnColor === 'TEXT',
				style: {
					opacity: '1',
					backgroundColor: 'transparent',
					border: 'none',
					color: theme.primary(theme).disabledColor,
				},
			},
			{
				condition: isFloat,
				style: {
					position: 'fixed',
					bottom: theme.spaces[20],
					right: theme.spaces[20],
					fontWeight: theme.font.weight600,
					fontSize: theme.font.size18,
					borderRadius: theme.spaces[28],
					padding: '10px 25px',
					width: 'auto',
					height: 'auto',
				},
			},
		],
		onFocus: {
			outline: 'none',
		},
	}
}
